import '../styles.scss';
import React, { useState } from 'react';
import track from 'react-tracking';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@edx/paragon';
import { injectIntl, defineMessages } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import InstructorCard from '../components/InstructorCard';

const MAX_DISPLAYED_INSTRUCTORS = 3;

const messages = defineMessages({
  'prospectus.course.instructors.title': {
    id: 'prospectus.course.instructors.title',
    description: 'Title header for instructors section of the course page',
    defaultMessage: 'About the instructors',
  },
  'prospectus.course.instructors.more': {
    id: 'prospectus.course.instructors.more',
    description: 'Label for expansion button to view more instructors',
    defaultMessage: 'Show more',
  },
  'prospectus.course.instructors.less': {
    id: 'prospectus.course.instructors.less',
    description: 'Label for collapse button to view more instructors',
    defaultMessage: 'Show less',
  },
});

function BaseInstructors({
  staff, intl, refProp, className, headingClassName,
}) {
  const hasHiddenInstructors = staff.length > MAX_DISPLAYED_INSTRUCTORS;
  const [showMoreInstructors, setShowMoreInstructors] = useState(false);

  const getVisibleInstructors = () => (
    showMoreInstructors ? staff : staff.slice(0, MAX_DISPLAYED_INSTRUCTORS)
  );

  return (
    <div className={
      classnames(
        'instructors',
        'mx-auto d-flex flex-column justify-content-center',
        className,
      )
    }
    >

      <h1
        className={
          classnames(
            'h1 nav-target text-center',
            'mb-3 pt-3 mt-3 pt-sm-5 mt-sm-2',
            headingClassName,
          )
        }
        ref={refProp}
      >
        {intl.formatMessage(messages['prospectus.course.instructors.title'])}
      </h1>
      <div className={
        classnames(
          'instructor-cards',
          'd-flex',
          'flex-wrap',
          'justify-content-center',
          'mx-auto',
          { 'justify-content-md-start': staff.length > 2 },
        )
      }
      >
        {getVisibleInstructors().map(instructor => (
          <InstructorCard
            {...instructor}
            key={instructor.uuid}
          />
        ))}
      </div>
      {hasHiddenInstructors
        && (
          <Button
            variant="tertiary"
            className="mx-auto"
            onClick={() => setShowMoreInstructors(!showMoreInstructors)}
          >
            <u>
              {showMoreInstructors
                ? intl.formatMessage(messages['prospectus.course.instructors.less'])
                : intl.formatMessage(messages['prospectus.course.instructors.more'])}
            </u>
          </Button>
        )}
    </div>
  );
}

BaseInstructors.propTypes = {
  intl: intlShape.isRequired,
  staff: PropTypes.arrayOf(PropTypes.shape(
    InstructorCard.propTypes,
    {
      uuid: PropTypes.string,
    },
  )),
  refProp: PropTypes.shape().isRequired,
  className: PropTypes.string,
  headingClassName: PropTypes.string,
};

BaseInstructors.defaultProps = {
  staff: [],
  className: '',
  headingClassName: '',
};

const Instructors = track({
  component: 'Instructors',
})(BaseInstructors);

export default injectIntl(Instructors);
